<template>
  <div>
    <v-menu bottom left min-width="200" offset-y origin="top right" transition="scale-transition">
      <template v-slot:activator="{ attrs, on }">
        <v-btn class="ml-2" min-width="0" text v-bind="attrs" v-on="on">
          <v-icon>mdi-account</v-icon>
        </v-btn>
      </template>
      <v-list :tile="false" flat nav>
        <template v-for="(p, i) in profile">
          <v-divider v-if="p.divider" :key="`divider-${i}`" class="mb-2 mt-2" />
          <v-list-item v-else :key="`item-${i}`" @click="menuAction(p.action)">
            <v-list-item-icon v-if="p.icon">
              <v-icon>{{ p.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="p.title" />
          </v-list-item>
        </template>
      </v-list>
    </v-menu>

    <theme-selector v-model="themeDialogOpen" />

    <v-dialog v-model="passwordDialogOpen" max-width="500">
      <v-card>
        <v-card-title class="headline">Zmień hasło</v-card-title>
        <v-card-text>
          <PasswordForm
            ref="form"
            :valid.sync="valid"
            :newPassword1.sync="newPassword1"
            :newPassword2.sync="newPassword2"
            :username="currentUsername"
            :requireCurrentPassword="false"
            :currentPassword.sync="currentPassword"
            @submit="changePasswordSubmit"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import Vue from 'vue'
  import { mapGetters, mapActions } from 'vuex'
  import passwordChangeMixin from '@/mixins/passwordChange'

  export default {
    name: 'DefaultAccount',
    mixins: [passwordChangeMixin],

    components: {
      ThemeSelector: () =>
        import(
          /* webpackChunkName: "theme-selector" */
          '@/components/ThemeSelector'
        ),
      PasswordForm: () =>
        import(
          /* webpackChunkName: "password-form" */
          '@/components/PasswordForm.vue'
        ),
    },

    data: () => ({
      profile: [
        { title: 'Wybór motywu', action: 'selectTheme', icon: 'mdi-palette' },
        { title: 'Zmień hasło', action: 'changePassword', icon: 'mdi-key' },
        { divider: true },
        { title: 'Wyloguj', action: 'logout', icon: 'mdi-logout' },
      ],
      themeDialogOpen: false,
      passwordDialogOpen: false,
    }),

    computed: {
      ...mapGetters('auth', ['isAuthenticated']),
      userStore() {
        return this.$store.state.user
      },
      currentUsername() {
        // Get email from user module state
        const userState = this.$store.state.user
        return userState.email ||
               userState.profile?.email ||
               userState.profile?.username ||
               ''
      }
    },

    watch: {
      passwordDialogOpen(isOpen) {
        if (isOpen) {
          // Clear password fields when opening dialog
          this.newPassword1 = ''
          this.newPassword2 = ''
          this.currentPassword = ''
          this.$nextTick(() => {
            if (this.$refs.form) {
              this.$refs.form.$refs.form.resetValidation()
            }
          })
        }
      }
    },    methods: {
      ...mapActions('auth', ['logout']),
      changePassword() {
        this.passwordDialogOpen = true
      },
      changePasswordSubmit() {
        this.handlePasswordChange({
          redirectAfterSuccess: false,
          closeDialog: () => {
            this.passwordDialogOpen = false
          }
        })
      },
      menuAction(name) {
        Vue.$log.info('Menu action' + name)
        switch (name) {
          case 'profile':
            this.$router.push('/profile')
            break
          case 'selectTheme':
            this.themeDialogOpen = true
            break
          case 'changePassword':
            this.changePassword()
            break
          case 'logout':
            this.logout()
            break
        }
        return this.appTitle + ' - ' + this.appTitle
      },
    },
  }
</script>
